const productrecommendation = () => {
  window.addEventListener("load", async () => {
    let url = document.URL;
    let baseIndex = "";
    let baseUrl = "";
    let handle = "";
    let currentVariantColor = "";
    let currentVariantSize = "";
    let optionTitle = "";

    if (url.includes("/products/")) {
      baseIndex = url.indexOf("/products/");
      baseUrl = url.substring(0, baseIndex);
      handle = document.querySelector(".product-details")?.dataset?.productHandle;

      const currentVariantColorElement = document.querySelector(
        ".variant-option__swatch-value",
      );
      if (currentVariantColorElement) {
        currentVariantColor = currentVariantColorElement.textContent;
      }
      const sizeFieldset = document.querySelector(
        'fieldset[data-fieldset-index="1"]'
      );
      
      const currentVariantSizeElement = sizeFieldset
        ?.querySelector('.select-button:checked')
        ?.closest('label')
        ?.querySelector('[data-key="variant-option-text"]');

      if (currentVariantSizeElement) {
        currentVariantSize = currentVariantSizeElement.textContent?.trim();
      }

      if (currentVariantSize != "") {
        optionTitle = currentVariantColor + " / " + currentVariantSize;
      } else {
        optionTitle = currentVariantColor;
      }
    }

    if (handle && currentVariantColor) {
      const productUrl = `${baseUrl}/products/${handle}.js`;
      try {
        const product = await getProductJson(productUrl);
        let waitFlag = false;

        let currentVariantId = "";
        product.variants.forEach((variant) => {
          // サイズとカラーで合体させたオプション名と一致するか確認する
          if (variant.title === optionTitle) {
            currentVariantId = variant.id;
          }
        });

        const recommendColors =
          document
            .querySelector(`#recommendColor-${currentVariantId}`)
            ?.value.split(",") || [];

        setTimeout(() => {
          changeRecommendProduct(
            baseUrl,
            product,
            currentVariantColor,
            recommendColors,
            waitFlag,
          );
        }, 1000);

        document.addEventListener("variant:update", function (event) {
          const product = event.detail.resource;
          const currentVariantColor = event.detail.resource.options[0];
          const currentVariantId = event.detail.resource.id;
          const recommendColors =
            document
              .querySelector(`#recommendColor-${currentVariantId}`)
              ?.value.split(",") || [];
          if (!waitFlag) {
            changeRecommendProduct(
              baseUrl,
              product,
              currentVariantColor,
              recommendColors,
              waitFlag,
            );
          }
        });
      } catch (error) {
        console.error("Failed to get product JSON:", error);
      }
    }
  });
};

const changeRecommendProduct = async (
  baseUrl,
  product,
  currentVariantColor,
  recommendColors,
  waitFlag,
) => {
  waitFlag = true;
  if (
    ["Color", "color"].includes(product.options[0]?.name) ||
    product.options[0]?.values?.includes(currentVariantColor) ||
    product.options[0].includes(currentVariantColor)
  ) {
    const recommendSection = document.querySelector("product-recommendations");
    const productCards = Array.from(
      recommendSection?.querySelectorAll("product-card") || [],
    );

    if (recommendSection && productCards.length) {
      const promises = productCards.map(async (productCard) => {
        const productCardImage = Array.from(
          productCard.querySelectorAll("img"),
        );
        const productCardLinkElement = productCard.querySelector("a");
        const productCardLink = productCardLinkElement
          ? productCardLinkElement.href
          : "";
        const handle = productCard.getAttribute("handle");
        const url = `${baseUrl}/products/${handle}.js`;
        const getProductInfo = await getProductJson(url);
        const defaultFeaturedImage = `https:${getProductInfo.featured_image}`;

        const recommends = document.querySelector(
          `script[id^="recommend-data-${handle}"]`,
        );
        const recommendData = JSON.parse(recommends.textContent);
        const recommendDataArray = recommendData.product.variants;

        let imageSrc = "";
        for (const variant of getProductInfo.variants) {
          const targetSku = variant.sku;
          const targetValue = true;
          if (variant.options[0] === currentVariantColor) {
            if (
              recommendDataArray.some(
                (item) =>
                  item.sku === targetSku &&
                  (!item.metafields ||
                    item.metafields["variant_data.color_visibility"] ===
                      targetValue),
              )
            ) {
              if (variant.featured_image) {
                imageSrc = variant.featured_image.src;
                updateProductCard(
                  productCardImage,
                  productCardLinkElement,
                  productCardLink,
                  imageSrc,
                  variant.id,
                );
                break;
              }
            }
          }
        }

        if (!imageSrc) {
          for (const recommendColor of recommendColors) {
            for (const variant of getProductInfo.variants) {
              const targetSku = variant.sku;
              const targetValue = true;
              if (variant.options[0] === recommendColor) {
                if (
                  recommendDataArray.some(
                    (item) =>
                      item.sku === targetSku &&
                      (!item.metafields ||
                        item.metafields["variant_data.color_visibility"] ===
                          targetValue),
                  )
                ) {
                  if (variant.featured_image) {
                    imageSrc = variant.featured_image.src;
                    updateProductCard(
                      productCardImage,
                      productCardLinkElement,
                      productCardLink,
                      imageSrc,
                      variant.id,
                    );
                    break;
                  }
                }
              }
            }
            if (imageSrc) break;
          }
        }

        if (!defaultFeaturedImage.includes("null")) {
          if (!imageSrc) {
            imageSrc = defaultFeaturedImage;
            updateProductCard(
              productCardImage,
              productCardLinkElement,
              productCardLink,
              imageSrc,
            );
          }
        } else {
          // console.log('noimage');
        }
      });

      await Promise.all(promises);
    }
  }
  waitFlag = false;
};

const updateProductCard = (
  images,
  linkElement,
  link,
  imageSrc,
  variantId = "",
) => {
  const newSrcset = `${imageSrc}&width=200 200w, ${imageSrc}&width=300 300w, ${imageSrc}&width=400 400w, ${imageSrc}&width=500 500w, ${imageSrc}&width=600 600w, ${imageSrc}&width=700 700w, ${imageSrc}&width=800 800w, ${imageSrc}&width=1000 1000w, ${imageSrc}&width=1200 1200w, ${imageSrc}&width=1400 1400w`;
  images[0].setAttribute("src", imageSrc);
  images[0].setAttribute("srcset", newSrcset);
  if (images[1]) {
    images[1].setAttribute("src", imageSrc);
    images[1].setAttribute("srcset", newSrcset);
  }
  if (link && variantId) {
    const newUrl = link.includes("?variant=")
      ? link.replace(/(\?variant=)[^\&]+/, `$1${variantId}`)
      : `${link}?variant=${variantId}`;
    linkElement.href = newUrl;
  }
};

const getProductJson = async (url) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to get product JSON:", error);
    throw new Error("Failed to get product JSON.");
  }
};

productrecommendation();
